import React, { useEffect, useState } from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';
import { CATEGORISED_TYPEAHEAD } from '../dropdown-templates';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button-head.css';

const valuesShape = PropTypes.shape({
  text: PropTypes.string,
  value: PropTypes.any,
});

const categoriesShape = PropTypes.shape({
  category: PropTypes.string,
  values: PropTypes.oneOfType([PropTypes.arrayOf(valuesShape), PropTypes.arrayOf(PropTypes.string)]),
});

const CategorisedDropDownList = React.memo(({
  optionTemplate,
  displayOptions,
  onClick,
}) => {
  const [displayValue, setDisplayValue] = useState(displayOptions);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    setDisplayValue(displayValue);
  }, [displayValue]);

  const searchHandler = (event) => {
    // Search function for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedValue = displayOptions.map((element) => (
      // Search function for filter the nested aaray by searching the any related text keywords
      { ...element, values: element.values.filter((values) => (values.text.toLowerCase().includes(searchQuery))) }
    ));
    // Filtered the displayed values that is not equal to zero value
    const filteredResult = displayedValue.filter((filtered) => (filtered.values.length !== 0));

    setDisplayValue(filteredResult);
    setSearchInput(event);
  };

  let displayItems = [];
  if (optionTemplate === CATEGORISED_TYPEAHEAD) {
    displayItems = [...displayOptions];
  }
  else {
    displayItems = [...displayValue];
  }

  return (
    <>
      { // Search div when default array length > 5
        displayOptions.length > 5 && (
          <div className="search-drop">
            <input
              className="Search-Input"
              type="text"
              onChange={(e) => searchHandler(e.target.value)}
              placeholder=" Please Search Here..."
              value={searchInput}
            />
            <div className={`no-result-msg ${displayValue.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
          </div>
        )
      }
      {
        displayItems.map((categoryObj) => {
          const {
            category,
            values,
          } = categoryObj;
          return (
            <li
              key={category}
              className="dropdown-item"
            >
              <div className="template-option template-option-categorised both-type">
                <h5 className="category-title">
                  {category}
                </h5>
                <ul className="category-list">
                  {
                    values.map((data) => {
                      // Typeahead data is an array where each string is both the value and text
                      // meanwhile standard data is an object with a value key and text key
                      const isTypeaheadData = optionTemplate === CATEGORISED_TYPEAHEAD;
                      const text = isTypeaheadData ? data : data.text;
                      const value = isTypeaheadData ? data : data.value;

                      return (
                        <li
                          key={value}
                          className="dropdown-item"
                        >
                          <div className="template-option-categorised-item">
                            <OptionButton
                              onClick={onClick}
                              option={value}
                            >
                              <p>{text}</p>
                            </OptionButton>
                          </div>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </li>
          );
        })
      }
    </>
  );
});

CategorisedDropDownList.propTypes = {
  displayOptions: PropTypes.arrayOf(categoriesShape),
  onClick: PropTypes.func,
  optionTemplate: PropTypes.string,
};

export { CategorisedDropDownList };

